import { getLogger, errorToJson } from '@williamhill/rosi-ui-shared/src/lib/logger-plus';
import { NewContentstackState } from '@williamhill/rosi-ui-shared/src/store/reducers/content-stack/content-stack.reducer';
import { Buffer } from 'buffer';

const logger = getLogger('ticket-logo');

import axios, { AxiosResponse } from 'axios';

export type Logo = Record<'content' | 'format', string> | null;

export async function requestTicketLogoFromContentstack(contentstack: NewContentstackState | null) {
  return contentstack?.other?.ticket_logo?.url
    ? createLogoFromResponse(await requestLogo({ url: contentstack.other?.ticket_logo.url }))
    : undefined;
}

async function requestLogo({ url }: { url: string }) {
  try {
    return await axios.get(url, { responseType: 'arraybuffer' });
  } catch (error) {
    logger.error({ error: errorToJson(error) }, 'Request for ticket logo failed');
    return null;
  }
}

function createLogoFromResponse(response: AxiosResponse | null): Logo {
  return (
    response && {
      content: Buffer.from(response.data, 'binary').toString('base64'),
      format: response.headers['content-type']
    }
  );
}
